import React, { useState, useEffect, useRef } from 'react';
import { STATIC_RESOURCE } from "@/utils/tools";
import AiAssistant from "../../pages/aiAssistant/index";
import { useLocation } from 'react-router-dom';
import { storage } from '@/utils/storage';
const AiFloatButton = () => {
  const token = storage.get('token') || true;
  const [aiModalVisible, setAiModalVisible] = useState(false);
  const [aiBtnPosition, setAiBtnPosition] = useState({ right: 16, bottom: 120 });
  const [isDragging, setIsDragging] = useState(false);
  const location = useLocation();
  const dragRef = useRef({
    startX: 0,
    startY: 0,
    startRight: 16,
    startBottom: 120,
    moved: false,
    isDragging: false,
    currentRight: 16,
    currentBottom: 120
  });
  // 拖拽开始
  const handleDragStart = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    const clientY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
    dragRef.current = {
      ...dragRef.current,
      startX: clientX,
      startY: clientY,
      startRight: dragRef.current.currentRight,
      startBottom: dragRef.current.currentBottom,
      moved: false,
      isDragging: true
    };
    setIsDragging(true);
  };

  // 拖拽中
  const handleDragMove = (e) => {
    if (!dragRef.current.isDragging) return;
    if (e.cancelable) e.preventDefault();
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const clientY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
    const deltaX = dragRef.current.startX - clientX;
    const deltaY = dragRef.current.startY - clientY;

    if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
      dragRef.current.moved = true;
    }

    const btnWidth = 74;
    const btnHeight = 59;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let newRight = dragRef.current.startRight + deltaX;
    let newBottom = dragRef.current.startBottom + deltaY;

    newRight = Math.max(0, Math.min(newRight, viewportWidth - btnWidth));
    newBottom = Math.max(0, Math.min(newBottom, viewportHeight - btnHeight));

    dragRef.current.currentRight = newRight;
    dragRef.current.currentBottom = newBottom;
    setAiBtnPosition({ right: newRight, bottom: newBottom });
  };

  // 拖拽结束 吸附到最右侧
  const handleDragEnd = () => {
    if (!dragRef.current.isDragging) return;
    dragRef.current.isDragging = false;
    setIsDragging(false);
    const snapRight = 16;
    dragRef.current.currentRight = snapRight;
    setAiBtnPosition(prev => ({ ...prev, right: snapRight }));
  };

  const handleAiBtnClick = () => {
    if (dragRef.current.moved) return;
    setAiModalVisible(prev => !prev);
  };

  useEffect(() => {
    const onMouseMove = (e) => handleDragMove(e);
    const onMouseUp = () => handleDragEnd();
    const onTouchMove = (e) => handleDragMove(e);
    const onTouchEnd = () => handleDragEnd();

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd);

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    };
  }, []);

  useEffect(() => {
    dragRef.current.currentRight = aiBtnPosition.right;
    dragRef.current.currentBottom = aiBtnPosition.bottom;
  }, [aiBtnPosition.right, aiBtnPosition.bottom]);

  // 关闭弹窗
  const closeAiChat = () => {
    setAiModalVisible(false);
  };

  if (location.pathname.includes('/login') || !token) return null;

  return (
    <>
      <div
        className="ai-float-btn"
        style={{
          right: aiBtnPosition.right,
          bottom: aiBtnPosition.bottom,
          transition: isDragging ? 'none' : 'right 0.3s ease, bottom 0.3s ease',
        }}
        onMouseDown={handleDragStart}
        onTouchStart={handleDragStart}
        onClick={handleAiBtnClick}
      >
        <img
          src={`${STATIC_RESOURCE}/cp_gsp/home/RobotGif.gif`}
          className="ai-float-icon"
          alt="AI助手"
        />
      </div>
      {aiModalVisible && <AiAssistant closeAiChat={closeAiChat} />}
    </>
  );
};

export default AiFloatButton;